import { validateNumber, numberErrorCode } from '../../utility';

export const audienceAdsOptionKeys = {
  Increase: 'Increase',
  Decrease: 'Decrease',
};

export function getAudienceData(audienceAds) {
  const data = audienceAds.useParentLevel ? audienceAds.parentLevelSettings : audienceAds.currentLevelSettings;
  return data;
}


export const audienceAdsOptions = i18n => [
  {
    key: audienceAdsOptionKeys.Increase, text: i18n.getString(_TL_('Increase by')),
  },
  {
    key: audienceAdsOptionKeys.Decrease, text: i18n.getString(_TL_('Decrease by')),
  },
];

export const getAudienceAds = (audienceAds) => {
  if (audienceAds.useParentLevel) {
    return {
      NativeBidAdjustment: null,
    };
  }

  const {
    currentLevelSettings,
  } = audienceAds;

  const {
    option,
    value,
  } = currentLevelSettings;

  if (option === audienceAdsOptionKeys.Decrease) {
    return {
      NativeBidAdjustment: -value,
    };
  }
  return {
    NativeBidAdjustment: value,
  };
};

const maxIn = 900;
const maxDe = 100;

const getMinMax = (data) => {
  if (data == null) {
    return {
      min: 0,
      max: maxIn,
    };
  }

  if (data.option === audienceAdsOptionKeys.Increase) {
    return {
      min: 0,
      max: maxIn,
    };
  }
  return {
    min: 0,
    max: maxDe,
  };
};

export const getAudienceAdsDetails = ({ rawData, i18n }) => {
  const data = getAudienceData(rawData);
  let { value } = data;
  const { option } = data;
  value = option === audienceAdsOptionKeys.Increase ? value : -value;
  return i18n.getString(_TL_('Audience ads bid adjustment: {{value}}%'), { value });
};

export const validateAudienceAds = (rawData) => {
  const data = getAudienceData(rawData);
  const { min, max } = getMinMax(data);
  const { value } = data;
  return validateNumber({
    value, min, max, shouldBePositive: true, isInteger: true,
  });
};

export const isAudienceAdsValid = rawData => validateAudienceAds(rawData) == null;

export const getAudiencesAdsErrorMsg = ({
  code, i18n,
}) => {
  switch (code) {
    case numberErrorCode.RequiredField:
      return i18n.getString(_TL_('The bid adjustment cannot be empty.'));
    case numberErrorCode.InValidNumber:
    case numberErrorCode.NotPositive:
    case numberErrorCode.WholeNumber:
      return i18n.getString(_TL_('Enter a positive, whole number.'));
    case numberErrorCode.OutOfRange:
      return i18n.getString(_TL_('The maximum increase is {{maxIn}}%; the maximum decrease is {{maxDe}}%.'), { maxIn, maxDe });
    default:
      return null;
  }
};
